import { Box, Typography } from '@mui/material';
import React from 'react';
import { JuvareLogo } from '../JuvareLogo';
import { themeColors, themeMode } from '../JuvareTheme';
/**
 * Displays the "Powered by Juvare" branding with a clickable link to the Juvare website.
 *
 * @returns {JSX.Element} A JSX element containing styled typography and the Juvare logo.
 */
export const JuvareLogoFull = () => {
    return (React.createElement(Typography, { sx: { display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }, component: 'div', onClick: () => window.open('https://juvare.com', '_blank') },
        React.createElement(Box, { component: 'span', sx: {
                marginRight: '6px',
                fontSize: 12,
                color: themeColors.text.subtle,
                whiteSpace: 'nowrap',
            } }, "Powered by"),
        React.createElement(JuvareLogo, { type: themeMode === 'light' ? 'black' : 'default', text: true })));
};
